(function () {
    var didInit = false;
    function init() {
      if (!didInit) {
        didInit = true;
        console.log("Munchkin is init")
        Munchkin.init('365-LEA-623');
      }
    }
    var script = document.createElement("script");
    script.async = true;
    script.src = "//munchkin.marketo.net/munchkin.js";
    script.onreadystatechange = function () {
      if (this.readyState == 'complete' || this.readyState == 'loaded') {
        init();
      }
    }
    script.onload = init;
    document.head.appendChild(script);
  })();